import { render, staticRenderFns } from "./FaultTaskEdit.vue?vue&type=template&id=56a04939&scoped=true"
import script from "./FaultTaskEdit.vue?vue&type=script&lang=js"
export * from "./FaultTaskEdit.vue?vue&type=script&lang=js"
import style0 from "./FaultTaskEdit.vue?vue&type=style&index=0&id=56a04939&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a04939",
  null
  
)

export default component.exports